import React from 'react';
import styled from 'styled-components';

import { Stack } from '../../../stack/stack';
import { ToolIcon } from '../tool-icon';
import { SettingsPanel } from './settings-panel/settings-panel';

type Props = {
  children: React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
  toolbarRef: React.RefObject<HTMLElement>;
  tooltip?: {
    text: React.ReactNode;
    title?: string;
  };
};

const WrapWithSettingsIcon = (props: Props) => {
  const [settingsOpen, setSettingsOpen] = React.useState(false);

  return (
    <IconContainer direction="row" spacing={'0.1em'}>
      {props.children}

      <SettingsPanel
        content={props.content}
        mainAxisOffset={15}
        toolbarRef={props.toolbarRef}
        onToggle={setSettingsOpen}
      >
        <ToolIcon
          active={settingsOpen}
          disabled={props.disabled}
          icon={['fas', 'gear']}
          tooltip={settingsOpen ? undefined : props.tooltip}
        />
      </SettingsPanel>
    </IconContainer>
  );
};

const IconContainer = styled(Stack)`
  position: relative;

  > :first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  > :nth-child(2) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding-left: 0.1em;
    padding-right: 0.1em;

    svg {
      width: 0.5em;
    }
  }
`;

export { WrapWithSettingsIcon };
